// extracted by mini-css-extract-plugin
export default {"base":"vp_IGkDd","silent":"vp_MYC_r","block":"vp_N5M3r"};